import { render } from "./SendersManagerModal.vue?vue&type=template&id=982e830e"
import script from "./SendersManagerModal.vue?vue&type=script&lang=js"
export * from "./SendersManagerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__